module.exports = __webpack_public_path__ + "static/scale-model-of-first-friday-hop-in-louisville-kentucky-e484fb509b135135edf4434440448df7.png";